import _ from 'lodash'
import Mustache from 'mustache'
import { formatNumber } from 'core/service/lib/number-format'
import MESSAGES from 'core/data-model/constants/bi-messages'
import CONSTANTS from 'core/data-model/constants/messages'
import { _getMessageUnderiShieldPolicyValueTable } from 'core/service/benefit-illustration/policy-value'
import { formatFromZeroToDash } from 'core/service/pdf-generation/utils/table-utils'
import { isAnnuallyPensionType, getPensionTypeString } from 'core/service/benefit-illustration/products/retirement'
import { calculatePageAmountPolicyValueTable } from 'core/service/pdf-generation/products/common/logic'

export const _breakLine = (text) => {
  const premiumPattern = /^(เบี้ยประกันภัย)(สัญญา.+)$/
  const deathBenefitPattern = /^(ความคุ้มครอง)(การเสียชีวิต)$/
  const surrenderCashPattern = /^(มูลค่าเวนคืน)(เงินสด)$/
  const savingWithCompany = /^(กรณีรับเป็น)(เงินสด)$/

  const patterns = [premiumPattern, deathBenefitPattern, surrenderCashPattern, savingWithCompany]

  // add space to trick pdfmake to do line wrapping for us
  const breakByFirstMatched = ([p, ...rest]) => (text.match(p) ? text.replace(p, '$1 $2') : breakByFirstMatched(rest))

  return breakByFirstMatched(patterns)
}

const rowHeightConfig = { lineHeight: 0.75, margin: [0, -3, 0, 0] }

const getBuildBumnanSmartPolicyValueRow = (yearEndPolicy, pensionType, pensionAge) => {
  if (isAnnuallyPensionType(pensionType)) {
    return buildBumnanSmartAnnuallyPolicyValueRowWithNoRiderAndTotalPremium(yearEndPolicy)
  } else {
    return buildBumnanSmartMonthlyPolicyValueRowWithNoRiderAndTotalPremium(yearEndPolicy, pensionAge)
  }
}

const buildBumnanSmartMonthlyPolicyValueRowWithNoRiderAndTotalPremium = (yearEndPolicy, pensionAge) => [
  {
    text: Number(yearEndPolicy.age.value) - 1,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.yearEndPolicy,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.age.value > pensionAge ? yearEndPolicy.monthEndPolicy : '',
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.annualBasicPremium === 0 ? '-' : formatNumber(yearEndPolicy.annualBasicPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text:
      yearEndPolicy.cumulativeBasicPremium === 0 ? '-' : formatNumber(yearEndPolicy.cumulativeBasicPremium, 2, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text:
      yearEndPolicy.surrenderCash === 0
        ? '-'
        : // $$FlowFixMe
          formatNumber(yearEndPolicy.surrenderCash, 0, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.deathBenefit === 0 ? '-' : formatNumber(yearEndPolicy.deathBenefit, 2, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.pensionPerYear, 2)),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.cumulativePersionAmount, 2)),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.pensionTotal, 2, true)),
    alignment: 'right',
    ...rowHeightConfig,
  },
]

const buildBumnanSmartAnnuallyPolicyValueRowWithNoRiderAndTotalPremium = (yearEndPolicy) => [
  {
    text: Number(yearEndPolicy.age.value) - 1,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.yearEndPolicy,
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.annualBasicPremium === 0 ? '-' : formatNumber(yearEndPolicy.annualBasicPremium, 2),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text:
      yearEndPolicy.cumulativeBasicPremium === 0 ? '-' : formatNumber(yearEndPolicy.cumulativeBasicPremium, 2, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text:
      yearEndPolicy.surrenderCash === 0
        ? '-'
        : // $$FlowFixMe
          formatNumber(yearEndPolicy.surrenderCash, 0, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    text: yearEndPolicy.deathBenefit === 0 ? '-' : formatNumber(yearEndPolicy.deathBenefit, 2, true),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.pensionPerYear, 2)),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.cumulativePersionAmount, 2)),
    alignment: 'right',
    ...rowHeightConfig,
  },
  {
    // $$FlowFixMe
    text: formatFromZeroToDash(formatNumber(yearEndPolicy.pensionTotal, 2, true)),
    alignment: 'right',
    ...rowHeightConfig,
  },
]

const getBuildBumnanSmartTotalPolicyValueRow = (policyValue, pensionType) => {
  if (isAnnuallyPensionType(pensionType)) {
    return buildBumnanSmartAnnuallyTotalPolicyValueRowWithNoRiderAndTotalPremium(policyValue)
  } else {
    return buildBumnanSmartMonthlyTotalPolicyValueRowWithNoRiderAndTotalPremium(policyValue)
  }
}

const getWidthBumnanSmartHeader = (pensionType) => {
  const widthAnnuallyNoRiderAndTotalColumn = [25, 25, 50, 60, 61, 61, 58, 58, 58]
  const widthTableAnnually = widthAnnuallyNoRiderAndTotalColumn

  const widthMonthlyNoRiderAndTotalColumn = [25, 25, 15, 50, 60, 56, 56, 53, 53, 53]
  const widthTableMonthly = widthMonthlyNoRiderAndTotalColumn

  const isAnnuallyPension = isAnnuallyPensionType(pensionType)
  return isAnnuallyPension ? widthTableAnnually : widthTableMonthly
}

const getBuildBumnanSmartHeader = (pensionType) => {
  if (isAnnuallyPensionType(pensionType)) {
    return buildBumnanSmartAnnuallyHeaderTableWithNoRiderAndTotalPremium()
  } else {
    return buildBumnanSmartMonthlyHeaderTableWithNoRiderAndTotalPremium()
  }
}

const buildBumnanSmartMonthlyTotalPolicyValueRowWithNoRiderAndTotalPremium = (policyValue) => [
  '',
  '',
  '',
  {
    text: policyValue.subtotalAnnualBasicPremium === 0 ? '-' : formatNumber(policyValue.subtotalAnnualBasicPremium, 2),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  '',
  '',
  '',
  {
    text:
      policyValue.subtotalPensionAmount === 0
        ? '-'
        : // $$FlowFixMe
          formatNumber(policyValue.subtotalPensionAmount, 2, true),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  '',
  '',
]

const buildBumnanSmartAnnuallyTotalPolicyValueRowWithNoRiderAndTotalPremium = (policyValue) => [
  '',
  '',
  {
    text: policyValue.subtotalAnnualBasicPremium === 0 ? '-' : formatNumber(policyValue.subtotalAnnualBasicPremium, 2),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  '',
  '',
  '',
  {
    text:
      policyValue.subtotalPensionAmount === 0
        ? '-'
        : // $$FlowFixMe
          formatNumber(policyValue.subtotalPensionAmount, 2, true),
    alignment: 'right',
    bold: true,
    ...rowHeightConfig,
  },
  '',
  '',
]

let disclaimer = {
  stack: [
    `${MESSAGES.NOTE}:`,
    MESSAGES.RETIREMENT_POLICY_VALUE_NOTE_1,
    MESSAGES.RETIREMENT_POLICY_VALUE_NOTE_2,
    MESSAGES.RETIREMENT_POLICY_VALUE_NOTE_3,
  ],
  style: 'disclaimer',
  pageBreak: '',
}

export const RetirementShowMessageUnderPdfTable = ({ policyValue, basicPlan }) => {
  const message = _getMessageUnderiShieldPolicyValueTable({
    policyValue,
    basicPlan,
  })
  if (message) {
    return {
      stack: [{ text: message, color: 'red', fontSize: 11, alignment: 'center' }],
    }
  } else return { text: '' }
}

const buildBumnanSmartPolicyValueTable = (policyValue, pensionType, basicPlan, selectedModelFactorLabel) => {
  const pensionAge = basicPlan?.pensionAge ?? 60
  const isIRRDesc_2 = selectedModelFactorLabel === 'รายเดือน' || selectedModelFactorLabel === 'รายหกเดือน'
  const policyValueTables = []
  let rowsPerPage = isIRRDesc_2
    ? pensionType === 'monthly'
      ? [41, 51, 51, 51, 51, 51, 51, 51, 51, 51, 51, 51, 51, 51, 51, 51]
      : [43, 48, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50]
    : pensionType === 'monthly'
    ? [45, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48]
    : [47, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50]

  const offsets = rowsPerPage.reduce((acc, n, i) => {
    acc.push((acc[i - 1] ?? 0) + (i === 0 ? 0 : rowsPerPage[i - 1]))
    return acc
  }, [])

  // if (rowsPerPage[0] === policyValue.yearEndPolicyValues.length) {
  //   rowsPerPage[0] = rowsPerPage[0] - 1
  // }
  const pageAmount = calculatePageAmountPolicyValueTable(policyValue, rowsPerPage)
  _.times(pageAmount, (currentPage) => {
    const start = offsets[currentPage]
    const end = start + rowsPerPage[currentPage]

    policyValueTables.push({
      table: {
        headerRows: 1,
        widths: getWidthBumnanSmartHeader(pensionType),
        body: [
          ...getBuildBumnanSmartHeader(pensionType),
          ...policyValue.yearEndPolicyValues
            .slice(start, end)
            .map((p) => getBuildBumnanSmartPolicyValueRow(p, pensionType, pensionAge)),
        ],
      },
      layout: 'lightBorder',
      style: 'table25PL',
    })
  })

  _.last(policyValueTables).table.body.push(getBuildBumnanSmartTotalPolicyValueRow(policyValue, pensionType))
  disclaimer = {
    stack: [
      `${MESSAGES.NOTE}:`,
      MESSAGES.RETIREMENT_POLICY_VALUE_NUMBER_NOTE_1,
      MESSAGES.RETIREMENT_POLICY_VALUE_NUMBER_NOTE_2,
    ],
    style: 'disclaimer',
    pageBreak: '',
    unbreakable: true,
  }
  setLayoutDisclaimer(policyValueTables, rowsPerPage, disclaimer)
  return policyValueTables
}

export const setLayoutDisclaimer = (
  policyValueTables,
  rowsPerPage,
  // $$FlowFixMe
  disclaimer
) => {
  const headerRow = 3
  const rowDisclaimer = 6
  const maxRowsDataforTable = 42
  const amountPage = policyValueTables.length ? policyValueTables.length : 1
  const maxofPage = rowsPerPage[amountPage - 1] + headerRow
  const rowsofPage = policyValueTables[amountPage - 1].table.body.length
  const isPageBreakforFirstPage =
    amountPage === 1 && policyValueTables[amountPage - 1].table.body.length > maxRowsDataforTable
  if (rowsofPage >= maxofPage - rowDisclaimer || isPageBreakforFirstPage) {
    disclaimer.pageBreak = 'before'
  } else {
    disclaimer.pageBreak = ''
  }
}

const buildBumnanSmartMonthlyHeaderTableWithNoRiderAndTotalPremium = () => {
  return [
    [
      {
        text: CONSTANTS.AGE,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.POLICY_VALUE_TABLE_INSURANCE_YEAR,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_MONTHLY,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.BASIC_PREMIUM,
        colSpan: 2,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      {
        text: [{ text: 'ผลประโยชน์' }, { text: 'ก่อน', decoration: 'underline' }, { text: 'รับเงินบำนาญ' }],
        colSpan: 2,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      {
        text: [{ text: 'ผลประโยชน์' }, { text: 'ช่วง', decoration: 'underline' }, { text: 'รับเงินบำนาญ' }],
        colSpan: 3,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      { text: '' },
    ],
    [
      '',
      '',
      '',
      {
        text: MESSAGES.PER_YEAR,
        rowSpan: 2,
        style: 'tableHeader',
        margin: [0, 15],
      },
      {
        text: MESSAGES.CUMULATIVE,
        rowSpan: 2,
        style: 'tableHeader',
        margin: [0, 15],
      },
      {
        text: MESSAGES.RETIREMENT_SURRENDER_VALUE_END_OF_YEAR,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 15],
      },
      {
        text: _breakLine(MESSAGES.DEATH_BENEFIT),
        rowSpan: 2,
        margin: [0, 15],
        style: 'tableHeader',
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_PENSION_MONTHLY_PDF,
        rowSpan: 2,
        margin: [0, 15],
        style: 'tableHeader',
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_CUMULATIVE_PENSION_AMOUNT,
        rowSpan: 2,
        margin: [0, 15],
        style: 'tableHeader',
      },
      {
        text: _breakLine(MESSAGES.DEATH_BENEFIT),
        rowSpan: 2,
        margin: [0, 15],
        style: 'tableHeader',
      },
    ],
    ['', '', '', '', '', '', '', '', '', ''],
  ]
}

const buildBumnanSmartAnnuallyHeaderTableWithNoRiderAndTotalPremium = () => {
  return [
    [
      {
        text: CONSTANTS.AGE,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.POLICY_VALUE_TABLE_INSURANCE_YEAR,
        rowSpan: 3,
        style: 'tableHeader',
        margin: [0, 26],
      },
      {
        text: MESSAGES.BASIC_PREMIUM,
        colSpan: 2,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      {
        text: [{ text: 'ผลประโยชน์' }, { text: 'ก่อน', decoration: 'underline' }, { text: 'รับเงินบำนาญ' }],
        colSpan: 2,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      {
        text: [{ text: 'ผลประโยชน์' }, { text: 'ช่วง', decoration: 'underline' }, { text: 'รับเงินบำนาญ' }],
        colSpan: 3,
        style: 'tableHeader',
        margin: [0, 10],
      },
      { text: '' },
      { text: '' },
    ],
    [
      '',
      '',
      {
        text: MESSAGES.PER_YEAR,
        rowSpan: 2,
        style: 'tableHeader',
        margin: [0, 10],
      },
      {
        text: MESSAGES.CUMULATIVE,
        rowSpan: 2,
        style: 'tableHeader',
        margin: [0, 10],
      },
      {
        text: MESSAGES.RETIREMENT_SURRENDER_VALUE_END_OF_YEAR,
        style: 'tableHeader',
        rowSpan: 2,
        margin: [0, 10],
      },
      {
        text: _breakLine(MESSAGES.DEATH_BENEFIT),
        rowSpan: 2,
        margin: [0, 10],
        style: 'tableHeader',
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_PENSION_PDF,
        rowSpan: 2,
        margin: [0, 10],
        style: 'tableHeader',
      },
      {
        text: MESSAGES.RETIREMENT_POLICY_VALUE_CUMULATIVE_PENSION_AMOUNT,
        rowSpan: 2,
        margin: [0, 10],
        style: 'tableHeader',
      },
      {
        text: _breakLine(MESSAGES.DEATH_BENEFIT),
        rowSpan: 2,
        margin: [0, 10],
        style: 'tableHeader',
      },
    ],
    ['', '', '', '', '', '', '', '', ''],
  ]
}

export const buildPolicyValueTable = (
  policyValue,
  pensionType,
  basicPlan,
  selectedModelFactorLabel
  // $$FlowFixMe
) => buildBumnanSmartPolicyValueTable(policyValue, pensionType, basicPlan, selectedModelFactorLabel)

export const policyValueTableSectionBumnanSmart = ({
  policyValue,
  basicPlan,
  pensionType,
  selectedModelFactorLabel,
}) => {
  const isIRRDesc_2 = selectedModelFactorLabel === 'รายเดือน' || selectedModelFactorLabel === 'รายหกเดือน'
  const selectedModelFactorLabelDisplay =
    selectedModelFactorLabel === 'รายหกเดือน' ? 'ราย 6 เดือน' : selectedModelFactorLabel
  return [
    {
      text: Mustache.render(MESSAGES.RETIREMENT_BUMNAN_READY_POLICY_VALUE_TABLE, {
        pensionType: getPensionTypeString(pensionType),
      }),
      style: 'title',
      pageBreak: 'before',
      alignment: 'center',
    },
    {
      text: Mustache.render(MESSAGES.RETIREMENT_BUMNAN_SMART_IRR_DESC_1, {
        IRR: _.get(policyValue, 'IRR', 0),
      }),
    },
    ...(isIRRDesc_2
      ? [
          {
            text: Mustache.render(MESSAGES.RETIREMENT_BUMNAN_SMART_IRR_DESC_2, {
              selectedModelFactorLabelDisplay,
            }),
          },
          {
            text: Mustache.render(MESSAGES.RETIREMENT_BUMNAN_SMART_IRR_DESC_3, {
              selectedModelFactorLabelDisplay,
            }),
          },
        ]
      : []),
    {
      text: '',
      margin: [0, 0, 0, 6],
    },
    ...buildPolicyValueTable(policyValue, pensionType, basicPlan, selectedModelFactorLabel),
    RetirementShowMessageUnderPdfTable({ policyValue, basicPlan }),
    disclaimer,
  ]
}
